import script from "./DropdownMenuItemLabelWithDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownMenuItemLabelWithDescription.vue?vue&type=script&setup=true&lang=js"

import "./DropdownMenuItemLabelWithDescription.vue?vue&type=style&index=0&id=5df7c780&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df7c780"]])

export default __exports__